import { render, staticRenderFns } from "./DialogToAdd.vue?vue&type=template&id=0b3b80e1"
import script from "./DialogToAdd.vue?vue&type=script&lang=js"
export * from "./DialogToAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports